import { service } from '@ember/service';
import Component from '@glimmer/component';
import ConfirmDirtyTransition from 'garaje/components/confirm-dirty-transition';
import type { ConfirmTaskInstance } from 'garaje/services/transition-confirm';
import type TransitionConfirmService from 'garaje/services/transition-confirm';
import { reads } from 'macro-decorators';

interface TransitionConfirmModalSignature {
  Args: Record<string, never>;
}

export default class TransitionConfirmModal extends Component<TransitionConfirmModalSignature> {
  @service declare transitionConfirm: TransitionConfirmService;
  @reads('transitionConfirm.displayConfirmTask.last.isRunning') declare isRunning: boolean;
  @reads('transitionConfirm.displayConfirmTask.last') declare lastTask: ConfirmTaskInstance;

  <template>
    {{#if this.isRunning}}
      <ConfirmDirtyTransition
        @headerMessage={{this.lastTask.headerMessage}}
        @bodyMessage={{this.lastTask.bodyMessage}}
        @cancelText={{this.lastTask.cancelText}}
        @confirmText={{this.lastTask.confirmText}}
        @confirm={{this.lastTask.continue}}
        @cancel={{this.lastTask.abort}}
      />
    {{/if}}
  </template>
}
